import React, { useEffect, useState, useRef } from 'react';
import cn from 'classnames';
import styles from '../Header.module.scss';
import LangService from 'services/LangService';
import { useCurrentUser, useCommunity } from 'context/community';
import { voleeApi } from 'api/VoleeApi';

/** Maps language code to display label (letters) */
const LANG_TO_LABEL = {
    RU: 'RU',
    EN: 'EN',
};

const getLabelForLang = (lang) => LANG_TO_LABEL[lang] ?? LANG_TO_LABEL.EN;

export async function applyCommunityLanguage(lang, { userId, community, setCommunity } = {}) {
    if (LangService.lang === lang) {
        return;
    }

    LangService.lang = lang;
    gtag('event', 'lang_selector_changed');
    localStorage.setItem('local', lang);
    localStorage.setItem('i18nextLng', lang.toLowerCase() === 'ru' ? 'ru-RU' : 'en-US');
    try { setCommunity?.({ ...community }); } catch (e) {}

    try {
        if (userId && community?.id) {
            await voleeApi.participant.updateLanguage(community.id, lang);
        } else if (userId) {
            await voleeApi.general.saveLangChoice(lang);
        }
    } catch (error) {
        await voleeApi.general.saveLangChoice(lang).catch(() => {});
    }
}

const LangSelector = ({ langChoices }) => {
    const { userId } = useCurrentUser();
    const { community, setCommunity } = useCommunity();
    const [showDropdown, setShowDropdown] = useState(false);
    const [isActive, setIsActive] = useState(false);
    const langIconRef = useRef(null);



    const handleIconClick = () => {
        if (!showDropdown) {
            gtag("event", `lang_selector_opened`);
        }
        setShowDropdown(!showDropdown);
        setIsActive(!isActive);
    };


    const handleLangChange = async (lang) => {
        setShowDropdown(false);
        setIsActive(false);
        await applyCommunityLanguage(lang, { userId, community, setCommunity });
    }

    const handleOutsideClick = (event) => {
        if (showDropdown && langIconRef.current && !langIconRef.current.contains(event.target)) {
            setShowDropdown(false);
            setIsActive(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        return () => document.removeEventListener('click', handleOutsideClick);
    }, [showDropdown]);

    // Don't show language selector if langChoices is null, undefined, or empty array
    // Language will be determined by community.configuration.lang
    if (!langChoices || !Array.isArray(langChoices) || langChoices.length === 0) {
        return <></>
    }

    return (
        <div className={cn(styles.langSelectorWrapper, {
            [styles.hasUser]: userId
        })}>
            <div className={cn(styles.langSelector, {
                [styles.active]: isActive

            })}>
                <span ref={langIconRef} className={styles.langFlagButton} onClick={handleIconClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleIconClick()} aria-label="Select language">
                    {getLabelForLang(LangService.lang)}
                </span>
            </div>
            {showDropdown && (
                <div className={cn(styles.langOptions)}>
                    {langChoices.map((lang) => (
                        <div className={cn(styles.langOption, { [styles.activeLang]: LangService.lang === lang })} data-active={LangService.lang === lang} key={lang} onClick={() => handleLangChange(lang)}>
                            <span className={styles.langOptionFlag}>{getLabelForLang(lang)}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LangSelector;
